/**
 * Abstraction on top of something like localStorage.
 *
 * One issue is that iOS might clear out localStorage. So we hedge our bets by using this facade
 */
import Server, {localStoragePrefix} from "../server";

export default class LocalDB {

    /**
     * Singleton instance
     */
    private static INSTANCE: LocalDB;

    static instance() {
        if (LocalDB.INSTANCE == null) {
            LocalDB.INSTANCE = new LocalDB();
        }
        return LocalDB.INSTANCE;
    }

    get(key0: string) : any {
        const key = localStoragePrefix() + key0;
        const str = window.localStorage.getItem(key);
        if (str == null) {
            return null;
        }
        return JSON.parse(str);
    }

    set(key0: string, value: any) {
        const key = localStoragePrefix() + key0;
        if (value == null) {
            window.localStorage.removeItem(key);
        } else {
            const str = JSON.stringify(value);
            try {
                window.localStorage.setItem(key, str);
            } catch (e) {
                // eg QuotaExceededError
                console.trace("Failed to set LocalDB", key, e);
                try {
                    window.localStorage.clear();
                } catch (e) {
                    console.trace("Failed to clear LocalDB", e);
                }
            }
        }
    }

}
